/**
 * Configuración centralizada de la aplicación
 * Principio: Single Source of Truth
 */

// URLs de la API
export const API_CONFIG = {
  // AWS API Gateway (admin Lambda endpoints)
  ADMIN_API_URL: import.meta.env.VITE_ADMIN_API_URL || 'https://5o1zrdp1sc.execute-api.us-east-1.amazonaws.com/production',
  // AWS WebSocket API Gateway (real-time updates)
  WS_URL: import.meta.env.VITE_WS_URL || 'wss://al9c9tpsmd.execute-api.us-east-1.amazonaws.com/production',
  TIMEOUT: 30000, // 30 segundos
};

// Configuración de Cognito
export const COGNITO_CONFIG = {
  USER_POOL_ID: import.meta.env.VITE_COGNITO_USER_POOL_ID,
  CLIENT_ID: import.meta.env.VITE_COGNITO_CLIENT_ID,
  REGION: import.meta.env.VITE_COGNITO_REGION || 'us-east-1',
};

// Configuración de WebSocket
export const WEBSOCKET_CONFIG = {
  RECONNECT_INTERVAL: 5000, // 5 segundos
  MAX_RECONNECT_ATTEMPTS: import.meta.env.DEV ? 3 : Infinity,
  HEARTBEAT_INTERVAL: 30000, // 30 segundos
};

// Configuración de OTA
export const OTA_CONFIG = {
  BULK_UPDATE_DELAY: 2000, // 2 segundos entre actualizaciones
  UPDATE_TIMEOUT: 60000, // 60 segundos de timeout por actualización
};

// Roles y permisos
export const ROLES = {
  ADMIN: 'admin',
  USER: 'user',
  RESELLER: 'reseller',
};

// Estados de dispositivos
export const DEVICE_STATUS = {
  ONLINE: 'online',
  OFFLINE: 'offline',
  UPDATING: 'updating',
  ERROR: 'error',
};

// Tipos de mensajes WebSocket
export const WS_MESSAGE_TYPES = {
  DEVICE_UPDATE: 'DEVICE_UPDATE',
  STATS_UPDATE: 'STATS_UPDATE',
  DEVICE_LIST: 'DEVICE_LIST',
  // MQTT response events (from Lambda handlers)
  STATUS_RESPONSE: 'STATUS_RESPONSE',
  OTA_RESPONSE: 'OTA_RESPONSE',
  RESTART_RESPONSE: 'RESTART_RESPONSE',
  CONFIG_RESPONSE: 'CONFIG_RESPONSE',
};
